import { render } from "./FilterStatisticData.vue?vue&type=template&id=32ab1875&scoped=true"
import script from "./FilterStatisticData.vue?vue&type=script&lang=js"
export * from "./FilterStatisticData.vue?vue&type=script&lang=js"

import "./FilterStatisticData.vue?vue&type=style&index=0&id=32ab1875&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ab1875"]])

export default __exports__